import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'
import {
    requestIllustration,
    requestUpdateIllustration,
    requestClients,
    requestIndexes,
} from '../actions'
import IllustrationEdit from '../components/illustration/edit'

const IllustrationEditPage = (props) => {
    const params = useParams()

    useEffect(() => {
        props.requestIllustration(params.illustrationId)
        props.requestClients()
        props.requestIndexes()
    }, [])

    const updateHandler = (values) => {
        props.requestUpdateIllustration(params.illustrationId, values)
    }

    return <IllustrationEdit submitHandler={updateHandler} {...props} />
}

const mapStateToProps = (state) => {
    return {
        ...state.illustration,
        clients: state.clients,
        indexes: state.indexes,
    }
}

export default connect(mapStateToProps, {
    requestIllustration,
    requestUpdateIllustration,
    requestClients,
    requestIndexes,
})(IllustrationEditPage)
